module.exports = __webpack_public_path__ + "img/janov-photo.91fcd89a.jpg";